import script from "./ImagePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePanel.vue?vue&type=script&setup=true&lang=js"

import "./ImagePanel.vue?vue&type=style&index=0&id=1e436679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e436679"]])

export default __exports__